/* SPEC-004 product gallery thumbnail rail.
   Collapses the left thumbnail rail to 4 cells and adds a "+N more" toggle.
   Extracted from the per-template custom-liquid block used by the SPEC-003
   concept templates so the behavior is maintained in one place. */
(function () {
  var VISIBLE = 4;

  function findRail() {
    return document.querySelector('.gallery-thumbnails--left .product-gallery__thumbnails')
        || document.querySelector('.product-gallery__thumbnails');
  }

  function init() {
    var rail = findRail();
    if (!rail || rail.dataset.lkspThumbs) return;

    var cells = rail.querySelectorAll('.product-gallery__thumbnail');
    if (!cells.length) cells = rail.querySelectorAll('.gallery-cell');
    if (cells.length <= VISIBLE) return;

    rail.dataset.lkspThumbs = '1';
    rail.classList.add('lksp-collapsed');

    var more = cells.length - VISIBLE;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lksp-thumbs-toggle';
    btn.textContent = '+' + more + ' more';
    btn.setAttribute('aria-expanded', 'false');
    rail.appendChild(btn);

    btn.addEventListener('click', function () {
      var collapsed = rail.classList.toggle('lksp-collapsed');
      rail.classList.toggle('lksp-expanded-rail', !collapsed);
      if (collapsed) rail.scrollTop = 0;
      btn.textContent = collapsed ? '+' + more + ' more' : 'Show less';
      btn.setAttribute('aria-expanded', String(!collapsed));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Turbo builds the gallery after its own scripts run, and variant switches
     can rebuild it. Re-run a couple of times rather than racing it. */
  setTimeout(init, 800);
  setTimeout(init, 2500);
})();
